import CONSTANTS from '../constants'
import { getRequest } from '../../services'
import { APICONFIG } from '../config/apiConfig'
import { addEventLog } from '../../pages/warningCitation/redux/actions/EventsLog'


// Calls the API to get Booking History Data Initials
export const getDataBookingHistory = (page = '', search = '', sortBy = '', sortByOrder = '') => (dispatch) => {
    const payload = {
        page: page, 
        search: search, 
        sortBy: sortBy, 
        sortByOrder: sortByOrder
    }
    dispatch(addEventLog(payload, CONSTANTS.GET_BOOKING_HISTORY_REQUEST))
    dispatch({ type: CONSTANTS.GET_BOOKING_HISTORY_REQUEST })
    let url = `${APICONFIG.getBookingHistroyDataUrl}/page/${page}?`
    let endpoint = `${url}`
    if ((sortBy && sortBy !== '') && (search && search !== '')) {
        endpoint = `${url}search=${search}&sort=${sortBy}&sortBy=${sortByOrder}`
    } else if ((sortBy && sortBy !== '')) {
        endpoint = `${url}sort=${sortBy}&sortBy=${sortByOrder}`
    } else if ((search && search !== '')) {
        endpoint = `${url}search=${search}`
    } else {
        endpoint = `${url}`
    }
    return getRequest(endpoint).then((res) => {
        let resObject = {...payload, ...res} 
        dispatch(addEventLog(resObject, CONSTANTS.GET_BOOKING_HISTORY_SUCCESS))
        dispatch({ type: CONSTANTS.GET_BOOKING_HISTORY_SUCCESS, data: res.data })
        return res.data
    }).catch((err) => {
        let errObject = {...payload, ...err} 
        dispatch(addEventLog(errObject, CONSTANTS.GET_BOOKING_HISTORY_FAILURE))
        dispatch({ type: CONSTANTS.GET_BOOKING_HISTORY_FAILURE })
        return err
    })
}

export const getPassUserDetails = (id) => (dispatch) => {
    dispatch(addEventLog(id, CONSTANTS.GET_PERMIT_RATE_LIST_REQUEST))
    dispatch({ type: CONSTANTS.GET_BOOKING_ID_REQUEST })
    let url = `${APICONFIG.getBookingDataByID}/${id}`
    return getRequest(url).then((res) => {
        let resObject = { ...res, 'id' : id }
		dispatch(addEventLog(resObject, CONSTANTS.GET_BOOKING_ID_SUCCESS))
        dispatch({ type: CONSTANTS.GET_BOOKING_ID_SUCCESS, data: res.data })
        return res.data
    }).catch((err) => {
        let errObject = { ...err, 'id' : id }
		dispatch(addEventLog(errObject, CONSTANTS.GET_BOOKING_ID_FAILURE))
        dispatch({ type: CONSTANTS.GET_BOOKING_ID_FAILURE })
    })
}

export const cancelReservation = (id) => (dispatch) => {
    dispatch(addEventLog(id, CONSTANTS.GET_CANCELBOOKING_REQUEST))
    dispatch({ type: CONSTANTS.GET_CANCELBOOKING_REQUEST })
    return getRequest(`${APICONFIG.getCancelBookinhUrl}/${id}`).then((res) => {
        let resObject = { ...res, 'id' : id }
		dispatch(addEventLog(resObject, CONSTANTS.GET_CANCELBOOKING_SUCCESS))
        dispatch({ type: CONSTANTS.GET_CANCELBOOKING_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...err, 'id' : id }
		dispatch(addEventLog(errObject, CONSTANTS.GET_CANCELBOOKING_FAILURE))
        dispatch({ type: CONSTANTS.GET_CANCELBOOKING_FAILURE, errorMessage: err })
        return err
    })
}
